// extracted by mini-css-extract-plugin
export var cardHeader = "_tm-0";
export var reorderHandle = "_tm-3";
export var titleArea = "_tm-1";
export var titleAreaWithHandle = "_tm-2";